import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {LimitReachedMessage} from './LimitReachedMessage';
import {ModulePageHeader} from '../../../../components/ModulePageHeader/ModulePageHeader';
import {CompanyContext} from '../../../../contexts/CompanyContext/CompanyContext';
import {ModuleTypes, ScreeningApplicantModule} from '../../../../types/CompanyProductConfiguration/CompanyModule';

export const CompanyScreeningHeader = () => {
  const {t} = useTranslation();
  const {productConfiguration} = useContext(CompanyContext);

  const screeningModule = productConfiguration.data?.companyModules.find(
    (module) => module.identifier === ModuleTypes.ScreeningApplicants
  ) as ScreeningApplicantModule;

  const showBanner = screeningModule
    ? screeningModule.metaData.currentApplicantCount >= screeningModule.metaData.maxApplicantLimit
    : false;

  return (
    <>
      {showBanner && <LimitReachedMessage />}
      <ModulePageHeader
        moduleName={t('appHeader.moduleLabels.recruiting')}
        title={t('screeningModule.title')}
      />
    </>
  );
};
